import { useEffect } from 'react';
import { useSelector, useStore } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useRestaurantSettings } from '../../hooks/useRestaurantSettings';
import { matomoConfig, startMatomo, trackPageView } from '../../helpers/matomo';

// Volto remounts the app extras when the set of matching extras changes.
// Keep the last tracked address outside the component, so that a remount
// does not record the same page again.
let trackedUrl: string | null = null;

// Sends a page view to Matomo each time a visitor sees a new page.
// Logged-in users are not tracked.
const MatomoTracker = () => {
  const { pathname, search } = useLocation();
  const store = useStore();
  const settings = useRestaurantSettings();
  const token = useSelector((state: any) => state.userSession?.token);
  const loading = useSelector((state: any) =>
    Boolean(state.content?.get?.loading),
  );
  const config = matomoConfig(settings.matomo_url, settings.matomo_site_id);
  const base = config?.base;
  const siteId = config?.siteId;

  useEffect(() => {
    if (!base || !siteId || token) return;
    // The page starts to load its content during the render of a new
    // address, so the value from this render can be old. Read the store.
    if ((store.getState() as any).content?.get?.loading) return;
    const url = `${window.location.origin}${pathname}${search}`;
    if (url === trackedUrl) return;
    const referrer = trackedUrl;
    trackedUrl = url;
    startMatomo({ base, siteId });
    // Volto writes the document title in the next animation frame.
    window.requestAnimationFrame(() => trackPageView(url, referrer));
  }, [base, siteId, token, loading, pathname, search, store]);

  return null;
};

export default MatomoTracker;
